export default {
  hall1: {
    label: 'Sál 1',
    color: 'green',
  },
  hall2: {
    label: 'Sál 2',
    color: 'blue',
  },
  both: {
    color: 'gray',
    label: 'Dvě skupiny - Sál 1 a Sál 2',
    cardBackgroundColor: 'rgb(255, 81, 0)',
    isCross: true,
  },
  hall1Wide: {
    color: 'gray',
    label: 'Sál 1',
    cardBackgroundColor: 'rgb(255, 81, 0)',
    isCross: true,
  },
  restaurant: {
    color: 'gray',
    label: 'Restaurace',
    cardBackgroundColor: 'rgb(255, 81, 0)',
    isCross: true,
  },
  exhibitors: {
    color: 'gray',
    label: 'Vystavovatelé',
    cardBackgroundColor: 'rgb(255, 81, 0)',
    isCross: true,
  },
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/data/tracks.js